<template>
	<BasicDialog :width="'w-150 w-sm-75 w-md-50 w-lg-70 w-xl-50'">


		<div class="delete-account__title">Delete Account</div>


		<div class="delete-account__subtitle">
			Please fill out all fields to delete your account
		</div>


		<v-form @submit.prevent="submitForm" ref="formRef" class="delete-account__form">

			<CustomInput label="First Name" placeholder="First Name" v-model="form.firstName"
				:error-messages="v$.firstName.$errors.map((e: any) => e.$message)" @blur="v$.firstName.$touch()" required />

			<CustomInput label="Last Name" placeholder="Last Name" v-model="form.lastName"
				:error-messages="v$.lastName.$errors.map((e: any) => e.$message)" @blur="v$.lastName.$touch()" required />

			<CustomInput label="Email" placeholder="Email" v-model="form.email"
				:error-messages="v$.email.$errors.map((e: any) => e.$message)" @blur="v$.email.$touch()" readonly required />

			<CustomInput label="User ID" placeholder="User ID" v-model="form.userId"
				:error-messages="v$.userId.$errors.map((e: any) => e.$message)" @blur="v$.userId.$touch()" readonly required />

			<CustomInput label="Phone Number" placeholder="Phone Number" v-model="form.phoneNumber"
				:error-messages="v$.phoneNumber.$errors.map((e: any) => e.$message)" @blur="v$.phoneNumber.$touch()"
				required />

			<button type="submit" :loading="loading" class="button--primary rounded-pill py-3 px-8">
				Submit
			</button>

		</v-form>
	</BasicDialog>
</template>



<script setup lang="ts">

import log from 'loglevel';
import { useRouter } from 'vue-router';
import { ref, reactive, watch } from 'vue';
import { useUserStore } from '@/store/UserStore';
import { useVuelidate } from '@vuelidate/core';
import { useSnackbar } from '@/composables/useSnackbar';
import { UserService } from '@/api/services/UserService';
import { deleteAccountRules } from '@/utils/ValidationRules';
import CustomInput from '@/components/Common/CustomInput.vue';
import BasicDialog from '@/components/Common/Basic-Dialog.vue';

const router = useRouter();
const { showSnackbar } = useSnackbar();
const userStore = useUserStore();

const form = reactive({
	firstName: '',
	lastName: '',
	email: '',
	userId: '',
	phoneNumber: '',
});

watch(
	() => userStore.user,
	(newUser) => {
		if (newUser) {
			form.email = newUser.email || '';
			form.userId = String(newUser.id) || '';
		}
	},
	{ immediate: true }
);

const v$ = useVuelidate(deleteAccountRules, form);

const loading = ref(false);

const submitForm = async () => {
	v$.value.$touch();
	if (v$.value.$invalid) {
		showSnackbar({
			message: 'Please fill out all fields correctly.',
			color: 'error'
		});
		return;
	}

	const confirmation = prompt("Type 'DELETE' to confirm account deletion");
	if (confirmation !== 'DELETE') return;

	loading.value = true;
	try {
		const data = { ...form };
		await UserService.deleteUserAccount(data);
		showSnackbar({
			message: 'Your account deletion request has been sent.',
			color: 'success'
		});
		router.push('/');
	} catch (error) {
		log.error('Failed to send account deletion request:', error);
		showSnackbar({
			message: 'Failed to delete account. Please try again.',
			color: 'error'
		});
	} finally {
		loading.value = false;
	}
};

</script>